updatedIds